export const getElement = (selector?: string) => {
  if (!selector) return null;

  try {
    return document.querySelector<HTMLElement>(selector);
  } catch {
    return null;
  }
};
